import axios from "axios"
import store from "../store"
import { refresh, logoutUser } from "store/auth/login/loginSlice"
import { notification } from "antd"
// export const BASE_URL="http://localhost:5001";
export const BASE_URL="https://api-backend.playmaker-club.com";

const API_URL = `${BASE_URL}/api`

const axiosApi = axios.create({
  baseURL: API_URL,
})

// 1) Intercepteur de requêtes : ajoute toujours le access_token
axiosApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token")
  if (token) {
    // Ajouter Authorization si le token existe
    config.headers = config.headers || {}
    config.headers["Authorization"] = `Bearer ${token}`
  }
  return config
})

// 2) Intercepteur de réponses : gère le refresh et le logout
axiosApi.interceptors.response.use(
  (response) => response, // Retourner la réponse directement en cas de succès
  async (error) => {
    console.log(error) // Log de l'erreur pour débogage
    const prevRequest = error.config // Sauvegarder la requête précédente

    if (prevRequest?.url?.includes("/player/refreshToken")) {
      console.log("Refresh token failed, logging out.")
      store.dispatch(logoutUser())
      return Promise.reject(error)
    }

    if (
      error.response?.status === 401 && 
      !prevRequest._retry 
    ) {
      prevRequest._retry = true 

      try {
        if (axiosApi._isRetryingRefresh) {
          return Promise.reject(new Error("Refresh already in progress"))
        }
        axiosApi._isRetryingRefresh = true

        const result = await store.dispatch(refresh()) 
        axiosApi._isRetryingRefresh = false

        if (result.payload !== "Request failed with status code 401") {
          prevRequest.headers["Authorization"] = `Bearer ${result.payload}`
          return axiosApi(prevRequest) 
        } else {
          store.dispatch(logoutUser()) 
          return Promise.reject(new Error("Token refresh failed"))
        }
      } catch (refreshError) {
        axiosApi._isRetryingRefresh = false
        store.dispatch(logoutUser())
        return Promise.reject(refreshError)
      }
    }

    // erreur serveur
    if (error.response?.status === 500) {
      notification.error({ message: "Internal Server Error" })
    }

    return Promise.reject(error) // Retourner l'erreur dans les autres cas
  }
)

export default axiosApi

// Fonctions utilitaires pour effectuer des requêtes HTTP
export async function get(url, config = {}) {
  return axiosApi.get(url, config).then((r) => r.data)
}

export async function post(url, data, config = {}) {
  return axiosApi.post(url, data, config).then((r) => r.data)
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, data, config).then((r) => r.data)
}

export async function del(url, config = {}) {
  return axiosApi.delete(url, config).then((r) => r.data)
}
// import axios from "axios"
// import accessToken from "./jwt-token-access/accessToken"
// // import store from '../store/'
// import { refresh,logoutUser } from "store/auth/login/loginSlice"
// import { useDispatch } from "react-redux"
// import store from '../store'
// import { notification } from "antd"

// //apply base url for axios
// const API_URL = "http://localhost:5001/api"; // Set your API base URL here

// const axiosApi = axios.create({
//   baseURL: API_URL,
// })

// // axiosApi.defaults.headers.common["Authorization"] = token

// // Response interceptor for refresh token
// axiosApi.interceptors.response.use(
//   (response) => {
//     return response
//   },
//   async (error) => {
//     const prevRequest = error?.config

//     // Handle invalid refresh token case
//     if (
//       error?.response?.status === 404 &&
//       error?.response?.data?.error === "Invalid or expired refresh token"
//     ) {
//       store.dispatch(logoutUser())
//       return Promise.reject(error)
//     }

//     // Handle expired access token case
//     if (
//       error?.response?.status === 401 &&
//       error?.response?.data?.message === "Invalid or expired token." &&
//       !prevRequest?._retry
//     ) {
//       console.log('nepo')
//       try {
//         // Mark request as retried
//         prevRequest._retry = true

//         // Get new token
//         const result = await store.dispatch(refresh())
//         console.log(result.payload)

//         if (result?.payload) {
//           // Update request header with new token
//           prevRequest.headers["Authorization"] = `Bearer ${result.payload}`
          
//           // Retry the request
//           return axiosApi(prevRequest)
//         } else {
//           // If refresh failed without error but no token
//           store.dispatch(logoutUser())
//           return Promise.reject(new Error("Token refresh failed"))
//         }
//       } catch (refreshError) {
//         // If refresh threw an error
//         store.dispatch(logoutUser())
//         return Promise.reject(refreshError)
//       }
//     }

//     // Handle other errors
//     if (error?.response?.status === 500) {
//       notification.error({
//         message: "Internal Server Error",
//       })
//     }

//     return Promise.reject(error)
//   }
// )

// export async function get(url, config = {}) {
//   return await axiosApi.get(url, { ...config }).then(response => response.data)
// }

// export async function post(url, data, config = {}) {
//   return axiosApi
//     .post(url, { ...data }, { ...config })
//     .then(response => response.data)
// }

// export async function put(url, data, config = {}) {
//   return axiosApi
//     .put(url, { ...data }, { ...config })
//     .then(response => response.data)
// }

// export async function del(url, config = {}) {
//   return await axiosApi
//     .delete(url, { ...config })
//     .then(response => response.data)
// }
// export default axiosApi
